import { VYSION_ACTIONS } from '..';

const commonValues = {
  action: VYSION_ACTIONS.CLICK,
  component: 'Skip',
  path: '/join',
  page: 'Join',
};

const aboutCommonValues = {
  ...commonValues,
  page: 'About',
};
const photoUploadCommonValues = {
  ...commonValues,
  page: 'Photo Upload',
};

export const enum JoinClickVysionEventsEnum {
  CLICK_ABOUT_SKIP = 'joinAboutSkip',
  CLICK_ABOUT_SKIP_CLOSE = 'joinAboutSkipClose',
  CLICK_ABOUT_SKIP_NO_GO_BACK_AND_FINISH = 'joinAboutSkipNoGoBackAndFinish',
  CLICK_ABOUT_SKIP_YES_SKIP_FOR_NOW = 'joinAboutSkipYesSkipForNow',
  CLICK_PHOTO_UPLOAD_SKIP = 'joinPhotoUploadSkip',
  CLICK_PHOTO_UPLOAD_SKIP_CLOSE = 'joinPhotoUploadSkipClose',
  CLICK_PHOTO_SKIP_YES_SKIP_FOR_NOW = 'joinPhotoUploadSkipYesSkipForNow',
  CLICK_PHOTO_SKIP_NO_GO_BACK_AND_FINISH = 'joinPhotoUploadSkipNoGoBackAndFinish',
  CLICK_JOIN_NET_WORTH = 'joinNetWorth',
  CLICK_JOIN_CREATE_ACCOUNT = 'joinCreateAccount',
  CLICK_JOIN_SKIP_AND_FINISH = 'joinSkipAndFinish',
  CLICK_JOIN_FINISH = 'joinFinish',
}

export const joinClickVysionEvents = {
  [JoinClickVysionEventsEnum.CLICK_ABOUT_SKIP]: {
    ...aboutCommonValues,
    eventName: 'join-about-skip',
  },
  [JoinClickVysionEventsEnum.CLICK_ABOUT_SKIP_CLOSE]: {
    ...aboutCommonValues,
    eventName: 'join-about-skip-close',
    extraInfo: 'Close',
  },
  [JoinClickVysionEventsEnum.CLICK_ABOUT_SKIP_NO_GO_BACK_AND_FINISH]: {
    ...aboutCommonValues,
    eventName: 'join-about-skip-noGoBackAndFinish',
    extraInfo: 'No, go back and finish',
  },
  [JoinClickVysionEventsEnum.CLICK_ABOUT_SKIP_YES_SKIP_FOR_NOW]: {
    ...aboutCommonValues,
    eventName: 'join-about-skip-yesSkipForNow',
    extraInfo: 'Yes, skip for now',
  },

  // photo upload
  [JoinClickVysionEventsEnum.CLICK_PHOTO_UPLOAD_SKIP]: {
    ...photoUploadCommonValues,
    eventName: 'join-photoUpload-skip',
  },
  [JoinClickVysionEventsEnum.CLICK_PHOTO_UPLOAD_SKIP_CLOSE]: {
    ...photoUploadCommonValues,
    eventName: 'join-photoUpload-skip-close',
    extraInfo: 'Close',
  },
  [JoinClickVysionEventsEnum.CLICK_PHOTO_SKIP_YES_SKIP_FOR_NOW]: {
    ...photoUploadCommonValues,
    eventName: 'join-photoUpload-skip-yesSkipForNow',
    extraInfo: 'Yes, skip for now',
  },
  [JoinClickVysionEventsEnum.CLICK_PHOTO_SKIP_NO_GO_BACK_AND_FINISH]: {
    ...photoUploadCommonValues,
    eventName: 'join-photoUpload-skip-noGoBackAndFinish',
    extraInfo: 'No, go back and finish',
  },
  [JoinClickVysionEventsEnum.CLICK_JOIN_NET_WORTH]: {
    ...commonValues,
    component: 'Net Worth',
    eventName: 'join-networth',
  },
  [JoinClickVysionEventsEnum.CLICK_JOIN_CREATE_ACCOUNT]: {
    ...commonValues,
    component: 'Create Account Button',
    eventName: 'join-accountcreated',
  },
  [JoinClickVysionEventsEnum.CLICK_JOIN_SKIP_AND_FINISH]: {
    ...commonValues,
    page: 'Onboarding',
    component: 'Skip and Finish button',
    eventName: 'onb-completed',
  },
  [JoinClickVysionEventsEnum.CLICK_JOIN_FINISH]: {
    ...commonValues,
    page: 'Onboarding',
    component: 'Tutorial Page 3 Finish button',
    eventName: 'onb-completed-tut3',
  },
};
